import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADMIN, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const DCStatusMappingList = () => {
	const defaultSort = useMemo(() => [{ id: 'id', desc: true }], []);
	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'id', filterType: FilterType.number, show: false },
			{
				Header: 'deliveryCompanyID',
				accessor: 'deliveryCompId',
				filterType: FilterType.number
			},
			{
				Header: 'deliveryCompanyName',
				accessor: 'deliveryCompanyName',
				filterType: FilterType.string
			},
			{
				Header: 'dcIntegrationName',
				accessor: 'dcIntegrationName',
				filterType: FilterType.string
			},
			{
				Header: 'otoStatus',
				accessor: 'otoStatus',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ALL_STATUSES,
				renderCell: ListComponents.STATUS
			},
			{
				Header: 'dcStatus',
				accessor: 'dcStatus',
				filterType: FilterType.string
			},
			{
				Header: 'otoOrderStatusId',
				accessor: 'otoOrderStatusId',
				filterType: FilterType.number
			},
			{
				Header: 'otoGroupStatusName',
				accessor: 'otoGroupStatusName',
				filterType: FilterType.string
			},
			{
				Header: 'previousStatuses',
				accessor: 'previousStatuses',
				filterType: FilterType.string
			},
			{
				Header: 'otoStatusAction',
				accessor: 'otoStatusAction',
				filterType: FilterType.enum,
				enumName: ENUMS.OTO_OMS_STATUS
			}
		],
		[]
	);

	return (
		<div>
			<DynamicList
				id={DYNAMICLISTS.DC_STATUS_MAPPING_LIST}
				columns={columns}
				fetchUrl={ADMIN.STATUS_MANAGEMENT.GET_DC_STATUS_MAPPING_LIST}
				exportName="statusMapping"
				actionObjectType={ACTION_OBJECT_TYPES.ADMIN}
				showCheckbox={false}
				defaultSort={defaultSort}
			/>
		</div>
	);
};

export default DCStatusMappingList;
